import Axios from "axios";
import {
    SET_CATEGORY_LIST,
    UNSET_CATEGORY_LIST
  } from "@/store/mutation-types";
import { saveUpdateCategory, getCategoryList, generateCategoryCode } from "@/store/api";
// initial state
const state = {
  getCategoryList: [],
};

const getters = {
  getCategoryList(state) {
    return state.getCategoryList;
  },
};

const mutations = {
  [SET_CATEGORY_LIST](state, data) {
    state.getCategoryList = data;
  },
  [UNSET_CATEGORY_LIST](state) {
    state.getCategoryList = [];
  }
};

const actions = {

  saveUpdateCategory({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateCategory, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getCategoryList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getCategoryList, data)
        .then(function (response) {
          commit('SET_CATEGORY_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_CATEGORY_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getGeneratedCategoryCode({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(generateCategoryCode)
        .then((response) => {
          resolve(response.data.code);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default {
  state,
  getters,
  actions,
  mutations,
};
